import { TicketSearchCardContent, TicketSearchCardTitle } from './components/search-card/TicketSearchCard';
export { TicketSearchCardContent as ZorseTicketSearchCardContent, TicketSearchCardTitle as ZorseTicketSearchCardTitle };